<section class="page-container bg-primary">

  <div class="container h-100">

    <div class="row h-100 d-flex justify-content-center align-items-center">

      <div class="col-md-12">

        <a class="btn btn-link text-white ml-1 pb-4" [routerLink]="[ data.URL_HOME ] | localize"><i
            class="fas fa-arrow-left fa-2x"></i></a>

        <nav class="navbar navbar-dark bg-primary">

          <a class="navbar-brand d-flex align-items-center" [routerLink]="[ data.URL_HOME ] | localize">
            <img class="logo" src="./assets/imagens/logo_branca.png">
          </a>

          <div id="navbarNav" class="d-flex justify-content-end">

            <ul>

              <li class="drop-down">
                <a><i class="flag-icon {{ idiomaSelecionado.FLAG }} mr-lg-2"></i><span
                    class="d-none d-lg-inline">{{ idiomaSelecionado.TITULO }}</span><i
                    class="fas fa-angle-down ml-2"></i></a>
                <ul>
                  <li *ngFor="let idioma of idiomas">
                    <a *ngIf="idiomaSelecionado.CODIGO != idioma.CODIGO" (click)="alterarIdioma(idioma.CODIGO)"><i
                        class="flag-icon {{ idioma.FLAG }} mr-2"></i>{{ idioma.TITULO }}</a>
                  </li>
                </ul>
              </li>

            </ul>

          </div>

        </nav>

        <div class="col-md-12 pt-2 pb-2">

          <div class="row pb-4">

            <div class="col-md-6 my-auto h-100">
              <h3 class="text-warning">{{ data.TITULO }}</h3>
              <p class="text-white">{{ data.DESCRICAO }}</p>
            </div>

            <div class="col-md-6">

              <div class="card">

                <div class="card-body">

                  <div class="row d-flex justify-content-center">
                    <div class="col-md-12">
                      <h4 class="text-primary">{{ data.SUBTITULO }}</h4>
                    </div>
                  </div>

                  <div class="row d-flex justify-content-center">
                    <div class="col-md-12">
                      <hr class="mt-2">
                    </div>
                  </div>

                  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">

                    <div class="row d-flex justify-content-center">

                      <div class="col-md-12">

                        <div class="row">
                          <div class="col-md-6">
                            <div class="control-group">
                              <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_EMPRESA }} <span
                                    class="text-danger">*</span></label>
                                <input class="form-control form-control-sm" type="text" formControlName="formEmpresa">

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.EMPRESA">
                                  <span class="text-danger"
                                    *ngIf="formGroup.get('formEmpresa').hasError(validator.TYPE) && (formGroup.get('formEmpresa').dirty || formGroup.get('formEmpresa').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="control-group">
                              <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_NOME }} <span
                                    class="text-danger">*</span></label>
                                <input class="form-control form-control-sm" type="text" formControlName="formNome">

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.NOME">
                                  <span class="text-danger"
                                    *ngIf="formGroup.get('formNome').hasError(validator.TYPE) && (formGroup.get('formNome').dirty || formGroup.get('formNome').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <div class="control-group">
                              <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_EMAIL }} <span
                                    class="text-danger">*</span></label>
                                <input class="form-control form-control-sm" type="email" formControlName="formEmail">

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.EMAIL">
                                  <span class="text-danger"
                                    *ngIf="formGroup.get('formEmail').hasError(validator.TYPE) && (formGroup.get('formEmail').dirty || formGroup.get('formEmail').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="control-group">
                              <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_TELEFONE }} <span
                                    class="text-danger">*</span></label>
                                <input class="form-control form-control-sm" type="text" formControlName="formTelefone"
                                  maxlength="18">

                                <!-- mask="(99) 99999-9999" -->

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.TELEFONE">
                                  <span class="text-danger"
                                    *ngIf="formGroup.get('formTelefone').hasError(validator.TYPE) && (formGroup.get('formTelefone').dirty || formGroup.get('formTelefone').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <div class="control-group">
                              <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_PAIS }} <span
                                    class="text-danger">*</span></label>
                                <select class="form-control form-control-sm" formControlName="formPais">
                                  <option value="">
                                  <option *ngFor="let country of countrys" value="{{country.CODIGO}}">
                                    {{country.TITULO}}</option>
                                </select>

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.PAIS">
                                  <span class="text-danger"
                                    *ngIf="formGroup.get('formPais').hasError(validator.TYPE) && (formGroup.get('formPais').dirty || formGroup.get('formPais').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="control-group">
                              <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_USUARIO }} <span
                                    class="text-danger">*</span></label>
                                <input class="form-control form-control-sm" type="text" formControlName="formUsuario">

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.USUARIO">
                                  <span class="text-danger"
                                    *ngIf="formGroup.get('formUsuario').hasError(validator.TYPE) && (formGroup.get('formUsuario').dirty || formGroup.get('formUsuario').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-2">
                          <div class="col-md-12">
                            <div class="control-group">
                              <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_CONHECEU }}</label>
                                <input class="form-control form-control-sm" type="text"
                                  formControlName="formComoConheceu">
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="control-group">
                              <div class="form-group mb-0">
                                <button class="btn btn-primary rounded-0 w-100" type="submit"
                                  [disabled]="!formGroup.valid">{{ data.BOTAO }}</button>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>

                  </form>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>